var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 130.2",
    style: {
      enableBackground: "new 0 0 400 130.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#50545B;}\n\t.st1{fill:#E72C78;}\n\t.st2{fill:#FFD022;}\n\t.st3{fill:#328D36;}\n\t.st4{fill:#34363A;}\n\t.st5{fill:#CD2873;}\n\t.st6{fill:#E5B621;}\n\t.st7{fill:#2B6E2F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.2,81.5c0-1.7-0.6-3.1-1.9-4.2c-1.3-1.1-3.5-2.1-6.7-2.9c-3.9-0.9-6.9-2.3-9.1-4.1 c-2.2-1.8-3.3-4.1-3.3-6.8c0-2.9,1.2-5.3,3.5-7.2c2.4-1.9,5.4-2.9,9.1-2.9c4,0,7.2,1.1,9.6,3.3c2.4,2.2,3.5,4.8,3.5,7.7l-0.1,0.2 h-4.8c0-2.2-0.7-3.9-2.1-5.2c-1.4-1.3-3.5-2-6.1-2c-2.5,0-4.4,0.6-5.7,1.7c-1.3,1.1-2,2.6-2,4.4c0,1.6,0.7,2.9,2.2,4 c1.4,1.1,3.8,2,7,2.8c3.9,1,6.8,2.4,8.9,4.3c2,1.9,3,4.2,3,7c0,3-1.2,5.4-3.6,7.2c-2.4,1.8-5.6,2.7-9.5,2.7c-3.7,0-6.9-1-9.8-3 c-2.8-2-4.2-4.7-4.1-8l0.1-0.2h4.8c0,2.4,0.9,4.2,2.6,5.4c1.7,1.2,3.9,1.8,6.5,1.8c2.5,0,4.5-0.5,6-1.6 C166.4,84.8,167.2,83.4,167.2,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.3,76v14.8h-5V54h14.1c3.9,0,7,1,9.2,3c2.2,2,3.3,4.7,3.3,8c0,3.4-1.1,6-3.3,8c-2.2,2-5.2,3-9.2,3H182.3z  M182.3,72.1h9.1c2.5,0,4.4-0.7,5.6-2c1.2-1.3,1.8-3,1.8-5.1c0-2-0.6-3.7-1.9-5.1c-1.2-1.4-3.1-2-5.6-2h-9.1V72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.3,73.7h-16.9v13.2h19.5v3.9h-24.4V54h24.2v3.9h-19.2v11.9h16.9V73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.8,81.3h-15.4l-3.5,9.5h-5.1L250,54h4.3l14,36.8h-5.1L259.8,81.3z M245.9,77.2h12.4l-6.1-16.8H252 L245.9,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.6,74.2h-4.3v16.6h-5V54h5v16.3h3.8L293.3,54h5.5l0.1,0.1l-14.3,17.7l15.3,18.9l-0.1,0.1h-5.9L280.6,74.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.6,81.3h-15.4l-3.5,9.5h-5.1L316.9,54h4.3l14,36.8h-5.1L326.6,81.3z M312.8,77.2h12.4l-6.1-16.8h-0.2 L312.8,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.1,74.9v16h-5V54h13.3c4,0,7.1,0.9,9.2,2.7c2.1,1.8,3.2,4.4,3.2,7.8c0,1.9-0.5,3.5-1.5,4.9 c-1,1.4-2.4,2.5-4.3,3.3c2,0.7,3.5,1.7,4.4,3.2c0.9,1.5,1.3,3.3,1.3,5.5v3.5c0,1.1,0.1,2.2,0.4,3.1c0.3,0.9,0.7,1.7,1.3,2.2v0.6 h-5.1c-0.7-0.6-1.1-1.4-1.3-2.5c-0.2-1.1-0.3-2.3-0.3-3.4v-3.4c0-2-0.6-3.6-1.7-4.8c-1.2-1.2-2.7-1.8-4.7-1.8H343.1z M343.1,70.9 h7.8c2.8,0,4.8-0.5,6.1-1.6c1.2-1.1,1.9-2.7,1.9-4.9c0-2.1-0.6-3.7-1.8-4.8c-1.2-1.1-3.1-1.7-5.6-1.7h-8.4V70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.2,57.9h-11.8v32.9h-5V57.9h-11.8V54h28.6V57.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 5.1,
    transform: "matrix(-0.9825 -0.1862 0.1862 -0.9825 187.7625 82.6245)",
    className: "st0",
    width: 54.7,
    height: 54.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "111.4,62.9 119.5,64.5 129.7,10.7 129.7,10.7 120.1,17.3 120.1,17.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 75.3,
    className: "st1",
    width: 54.7,
    height: 54.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "8.5,75.3 0.2,75.3 0.2,130 0.2,130 8.5,121.8 8.5,121.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "54.9,121.8 54.9,130 0.2,130 0.2,130 8.5,121.8 8.5,121.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 15.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 70.3739 15.2606)",
    className: "st2",
    width: 54.7,
    height: 54.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "54.9,23.7 54.9,15.5 0.2,15.5 0.2,15.5 8.5,23.7 8.5,23.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "8.5,70.2 0.2,70.2 0.2,15.5 0.2,15.5 8.5,23.7 8.5,23.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "74.4,8.6 76,0.5 129.7,10.7 129.7,10.7 120.1,17.3 120.1,17.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1,
    y: 75.3,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -15.2657 190.1172)",
    className: "st3",
    width: 54.7,
    height: 54.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "60.1,121.8 60.1,130 114.8,130 114.8,130 106.5,121.8 106.5,121.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "106.5,75.3 114.8,75.3 114.8,130 114.8,130 106.5,121.8 106.5,121.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.6,33.7l-7.2-1.4c-0.7-0.1-1.4,0.3-1.5,1.1l-1,5.3c-0.1,0.7,0.3,1.4,1.1,1.5l7.2,1.4 c0.7,0.1,1.4-0.3,1.5-1.1l1-5.3C99.8,34.6,99.3,33.9,98.6,33.7z M94.7,37.2l-0.3,1.7l-0.9-0.2l0.3-1.7c-0.3-0.2-0.5-0.6-0.4-1 c0.1-0.6,0.7-0.9,1.2-0.8c0.6,0.1,0.9,0.7,0.8,1.2C95.3,36.8,95,37.1,94.7,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96,27.9c-2-0.4-3.9,0.9-4.3,2.9L91.5,32l1.3,0.2L93,31c0.2-1.3,1.5-2.1,2.8-1.9c1.3,0.2,2.1,1.5,1.9,2.8 l-0.2,1.2l1.3,0.2l0.2-1.2C99.3,30.2,98,28.2,96,27.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.619b02d84c4bdef1ee12fd070e03fcbf.svg";
export { ForwardRef as ReactComponent };